import React, {useState,useEffect} from 'react';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import './others.css';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label,Select,Modal,ModalHeader, Button } from "reactstrap";


export default function Operations() {

    const[orders, setAllorders] = useState([]);
    const[start,setStart] = useState('');
    const[end,setEnd] = useState('');
    const[company, setCompany] = useState('');
    const[email, setEmail] = useState("");
    const [midnightTime, setMidnightTime] = useState(null);
    const [search, setSearch] = useState('');
    const [store, setStore] = useState('');
    const [stores, setStores] = useState([]);
    const [modal,setModal] = useState(false);
    const [selectedOrder, setSelectedorder] = useState('');
    const [orderNumber, setOrdernumer] = useState('');
    const [customerName, setCustomername] = useState('');
    const [customerPhone, setCustomerphone] = useState('');
    const [storename, setStorename] = useState('');
    const [orderValue, setOrdervalue] = useState('');
    const [deliveryLocation, setDeliverylocation] = useState('');
    const [landmark, setLandmark] = useState('');
    const [deliveryType, setDeliverytype] = useState('');
    const [instructions, setInstructions] = useState('');
    const [createdAt, setCreatedAt] = useState('');
    const [allocatedAt,setAllocatedat] = useState('')
    const [dispatechedAt, setDispatchedat] = useState('');
    const [deliveredAt, setDeliveredat] = useState('');
    const [cancelledAt, setCancelledat] = useState('');
    const [status, setStatus] = useState('');
    const [distance, setDistance] = useState('');
    const [amount, setAmount] = useState('');
    const [rider, setRider] = useState('');
    const [tab, setTab] = useState(1);
    const [orderItems, setOrderitems] = useState([]);
    const [riders, setRiders] = useState([]);
    const [selectedRider, setSelectedrider]= useState([]);
    const [trips,setTrips] = useState('1');
    const [assignText, setAssigntext] = useState('Assign Order')
    const [deliverText, setDelivertext] = useState('Mark as delivered')
    const [dispatchText, setDispatchtext] = useState('Dispatch order')
    const [cancelText, setCanceltext] = useState('Cancel order')
    const [selectedStatus, setSelectedstatus] = useState('');

    const tab1=()=>{
        setTab(1)
    }
    const tab2=()=>{
        setTab(2)
    }
    const tab3=()=>{
        setTab(3)
    }
    

     useEffect(() => {
        const fetchProfile = async () => {
          try {
            const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
              credentials: 'include', // to send cookies
            });
            const data = await res.json();
    
            if (data.valid) {
              setEmail(data.email)
            } else {}
          } catch (error) {} 
        };
    
        fetchProfile();
      }, []);
    
      //get store id
      useEffect(()=>{
       const fetchData = async()=>{
          try{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
            const data = await res.json();
            setCompany(data.company)
          }
          catch(err){}
       }
    
       if(email){
        fetchData();
       }
       
      },[email]);


          useEffect(() => {
            const getMidnightTime = () => {
              const now = new Date();
              
              // Create a new date at 00:01 AM of the current day
              const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 1, 0, 0);
              
              // Convert to milliseconds since epoch
              const midnightTimeInMs = midnight.getTime();
              
              setMidnightTime(midnightTimeInMs);
            };
          
            getMidnightTime();
          }, []);
      
          const fetchOrders=async()=>{
                const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCompanyOrderstoday?company=${company}&today=${midnightTime}`);
                const data = await res.json();
                setAllorders(data)
              }
      
          useEffect(()=>{
              const fetchData=async()=>{
                const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCompanyOrderstoday?company=${company}&today=${midnightTime}`);
                const data = await res.json();
                setAllorders(data)
              }
          
              if(company && midnightTime){
                fetchData();
              }
          
            },[company,midnightTime])

      

    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setStart(millisecondsSinceEpoch);
    
    };
    const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setEnd(millisecondsSinceEpoch); 
      };

    useEffect(()=>{

        const getStores =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getMystores?company=${company}`);
            const data = await res.json();
            setStores(data)
        }

        const getRiders =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getMyriders?company=${company}`);
            const data=await res.json();
            setRiders(data)
        }

        getStores();
        getRiders();

    },[company])


    useEffect(()=>{
        const getOrders =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getOrdersbydate?start=${start}&end=${end}&company=${company}`);
            const data = await res.json();
            setAllorders(data)
        }

        if(company && start && end){
            getOrders();
        }

    },[company,start,end])

    useEffect(()=>{
        const searchOrder = async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/searchOrder?search=${search}&company=${company}`);
            const data = await res.json();
            setAllorders(data);

            
        }

        if(search){
                searchOrder()
            }

    },[search])

    const toggle =async(e)=>{
        const id = e.target.value;
        setSelectedorder(id);
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getThisorder?id=${id}`);
        const data = await res.json();
        setCustomername(data.customerName);
        setOrdernumer(data.orderNumber);
        setCustomerphone(data.customerPhone);
        setOrdervalue(data.orderValue);
        setStorename(data.store_name);
        setDeliverylocation(data.deliveryLocation);
        setLandmark(data.landmark);
        setDeliverytype(data.deliveryType);
        setInstructions(data.instructions);
        setCreatedAt(data.createdAt);
        setAllocatedat(data.allocatedAt);
        setDispatchedat(data.dispatchedAt);
        setDeliveredat(data.deliveredAt);
        setCancelledat(data.cancelledAt);
        setStatus(data.status);
        setDistance(data.distance);
        setAmount(data.amount);
        setRider(data.ridername);

        setModal(!modal);
    }

    useEffect(()=>{
        const getItems =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getOrderitems?orderNumber=${orderNumber}`);
            const data = await res.json();
            setOrderitems(data);
        }
        
        if(orderNumber){
            getItems();
        }

    },[orderNumber])

    const assignOrder =async()=>{
        if(selectedRider !== '' && trips !== ''){
            setAssigntext('Please wait')
            const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/assignOrder',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    selectedOrder,selectedRider,trips
                }),
                credentials:'include'
            })

            const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('Order has been assigned to rider. Ready for dispatch!');
                setAssigntext('Assign Order')
                fetchOrders();
                setModal(false);
            }
            else{
                setAssigntext('Assign Order')
                toast.error('Something went wrong. Please try again')
            }


        }
        else{
            toast.error('Please select rider and number of trips')
        }
    }

    const deliverOrder =async()=>{
        setDelivertext('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/deliverOrder',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({
                selectedOrder
            }),
            credentials:"include"
        })

        const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('Order has been marked as delivered');
                setDelivertext('Mark as delivered')
                fetchOrders();
                setModal(false);
            }
            else{
                setDelivertext('Mark as delivered')
                toast.error('Something went wrong. Please try again')
            }

        



    }

    const dispatchOrder =async()=>{
        setDispatchtext('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/dispatchOrder',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({
                selectedOrder
            }),
            credentials:"include"
        })

        const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('Order has been dispatched and en route to delivery');
                setDispatchtext('Dispatch order')
                fetchOrders();
                setModal(false);
            }
            else{
                setDispatchtext('Dispatch order')
                toast.error('Something went wrong. Please try again')
            }

        



    }

    
    const cancelOrder =async()=>{
        setCanceltext('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/cancelOrder',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({
                selectedOrder
            }),
            credentials:"include"
        })

        const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('Order has been cancelled');
                setCanceltext('Cancel order')
                fetchOrders();
                setModal(false);
            }
            else{
                setCanceltext('Cancel order')
                toast.error('Something went wrong. Please try again')
            }

        



    }



  return (
    <div className='pagesContainer'>
    <ToastContainer />
        <Breadcrumbs title="Easybox" breadcrumbItem="Operations" />
               
        <div className="card" style={{padding:'10px'}}>
        <div className="mb-4" id='searchContainer'>
        <Label className="form-label">Search order</Label>
        <Input
            name="search"
            className="form-control"
            placeholder="Search order"
            type="text"
            onChange={(e)=>{setSearch(e.target.value)}}
            value={search}

        />
                
        </div>
            <div className="filters">
            
                <div className="mb-4" id='mb'>
                    <Label className="form-label">From date</Label>
                    <Input
                        name="text"
                        className="form-control"
                        placeholder="Search order"
                        type="datetime-local"
                        onChange={handleDateChange}
                        // value={email}

                    />
                    
                </div>
                <div className="mb-4" id='mb'>
                    <Label className="form-label">To date</Label>
                    <Input
                        name="text"
                        className="form-control"
                        placeholder="Search order"
                        type="datetime-local"
                        onChange={handleDateChange2}
                        // value={email}

                    />
                    
                
                </div>

                <div className="mb-4" id='mb'>
                <Label className="form-label">Select store</Label>
                <select name="" id="" className="form-control" onChange={(e)=>{setStore(e.target.value)}}>
                    <option value="">All</option>
                    {stores.map((val)=>{
                        return(
                            <option value={val.store_id}>{val.store_name}</option>
                        )
                    })}
                   
                </select>
                
            </div>

            <div className="mb-4" id='mb'>
                <Label className="form-label">Select status</Label>
                <select name="" id="" className="form-control" onChange={(e)=>{setSelectedstatus(e.target.value)}}>
                    <option value="">All</option>
                    <option value="Pending">Pending</option>
                    <option value="Dispatch">Dispatch</option>
                    <option value="Transit">Transit</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Cancelled">Cancelled</option>
                    
                    
                   
                </select>
                
            </div>

            </div>
            {start == '' && end == '' &&
                <h5>Today orders({orders.length})</h5>
            }
            <hr className='divider' />
         
            <div className="table-responsive">
                <Table striped bordered hover>

                    <thead>
                        <tr>
                            
                            <th scope="col">#</th>
                            <th scope="col">Order Number</th>
                            <th scope="col">Created At</th>
                            <th scope="col">Order value</th>
                            <th scope="col">Customer</th>
                            <th scope="col">Contact</th>
                            <th scope="col">Location</th>
                            <th scope="col">Status</th>
                            
                        </tr>
                    </thead>
                    <tbody>

                        {orders.map((item,key)=>{

                            const postDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(item.createdAt)
                            const postTime =  new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(item.createdAt)

                            if(start == '' && end == '' && store == '' && selectedStatus == ''){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }


                            if(start !== '' && end == !'' && store == '' && selectedStatus == ''){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }


                            if(start !== '' && end !== '' && store == item.storeID && selectedStatus == ''){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }
                            if(start == '' && end == '' && store == item.storeID && selectedStatus == ''){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }

                            if(start == '' && end == '' && store == item.storeID && selectedStatus == item.status){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }

                            if(start == '' && end == '' && store == '' && selectedStatus == item.status){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }

                            if(start !== '' && end !== '' && store == '' && selectedStatus == item.status){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }

                            if(start !== '' && end !== '' && store == item.storeID && selectedStatus == item.status){
                                return(
                                <tr key={key}>


                                <td>{key+1}</td>
                                <td>
                                    <h5 className="mb-1 font-size-12"><button className='tableButton' value={item.id} onClick={toggle}>{item.orderNumber}</button></h5>
                                    
                                </td>
                                <td> {postDate},{postTime}</td>
                                <td>Kes. {item.orderValue}</td>
                                <td>{item.customerName}</td>
                                <td>{item.customerPhone}</td>

                                <td>
                                    {item.deliveryLocation.length > 10
                                        ? `${item.deliveryLocation.slice(0, 10)}...`
                                        : item.deliveryLocation}
                                    </td>
                                <td>
                                    {item.status == 'Delivered' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Pending' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Transit' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Dispatch' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                    </>
                                    }
                                    {item.status == 'Cancelled' &&
                                    <>
                                        <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                    </>
                                    }
                                    
                                </td>
                                

                                </tr>

                            )

                            }



                            
                        })}

                       
                    </tbody>
                </Table>
            </div>

        </div>

        <Modal isOpen={modal} toggle={toggle} size='lg'>
            <ModalHeader>Order #{orderNumber} - {status}</ModalHeader>
            <div className="modalContainer">
                <div className="modalBar">
                    <button onClick={tab1} className='topButton'>Basic information</button>
                    <button onClick={tab2} className='topButton'>Customer information</button>
                    <button onClick={tab3} className='topButton'>Delivery information</button>
                </div>
                {tab == 1 &&
                <>
                    <hr />
                    <h5>Basic information</h5>

                    <p><strong>Store: </strong>{storename}</p>
                    <p><strong>Value: </strong>Kes. {orderValue}</p>
                    <p><strong>Items: </strong></p>
                    {orderItems.map((val,index)=>{
                        return(
                            <p>{index+1}. {val.item} - {val.quantity} </p>
                        )
                    })}
                    {orderItems.length == 0 &&
                    <p>No items available</p>
                    
                    }
                    {status == 'Pending' &&
                        <>
                        <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                        <h6>Allocate order to rider</h6>
                        <div className="mb-4" id='mb'>
                       
                            <Label className="form-label">Select rider</Label>
                            <select name="" id="" className="form-control" onChange={(e)=>{setSelectedrider(e.target.value)}}>
                                <option selected disabled>Rider</option>
                                {riders.map((val)=>{
                                    return(
                                        <option value={val.rideremail}>{val.ridername}</option>
                                    )
                                })}
                            
                            </select>
                            
                        </div>
                        <div className="mb-4" id='mb'>
                       
                            <Label className="form-label">Trips</Label>
                            <select name="" id="" className="form-control" onChange={(e)=>{setTrips(e.target.value)}}>
                                <option selected disabled>Trips</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                            
                            </select>
                            
                        </div>

                        <Button color='success' onClick={assignOrder}>{assignText}</Button>
                        </>
                    }
                    {status == 'Dispatch' &&
                    <>
                        <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                        <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                        <h6>Reassign rider</h6>
                        <div className="mb-4" id='mb'>
                       
                            <Label className="form-label">Select rider</Label>
                            <select name="" id="" className="form-control" onChange={(e)=>{setSelectedrider(e.target.value)}}>
                                <option selected disabled>Rider</option>
                                {riders.map((val)=>{
                                    return(
                                        <option value={val.rideremail}>{val.ridername}</option>
                                    )
                                })}
                            
                            </select>
                            
                        </div>
                        <div className="actionButtons">
                        <Button color='info' onClick={assignOrder}>{assignText}</Button>
                        <Button color='success' style={{marginLeft:'2%'}} onClick={dispatchOrder}>{dispatchText}</Button>


                        </div>
                        
                        
                    </>
                    }
                    {status == 'Transit' &&
                    <>
                        <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                        <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                        <p><strong>Dispatch time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(dispatechedAt)}</p>
                        <div className="actionButtons">
                            <Button color='danger' onClick={cancelOrder}>{cancelText}</Button>
                            <Button color='success' style={{marginLeft:'2%'}} onClick={deliverOrder}>{deliverText}</Button>
                        </div>
                    </>
                    }
                    {status == 'Delivered' &&
                    <>
                        <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                        <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                        <p><strong>Dispatch time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(dispatechedAt)}</p>
                        <p><strong>Delivery time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(deliveredAt)}</p>
                    </>
                    }
                    {status == 'Cancelled' &&
                    <>
                        <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                        <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                        <p><strong>Dispatch time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(dispatechedAt)}</p>
                        <p><strong>Cancelation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(cancelledAt)}</p>
                    </>
                    }

                    
                   
                  
                    


                </>
                }

                {tab == 2 &&
                <>
                    <hr />
                    <h5>Customer information</h5>
                    <p><strong>Name: </strong>{customerName}</p>
                    <p><strong>Phone: </strong>{customerPhone}</p>
                    <p><strong>Instructions: </strong>{instructions}</p>
                </>
                }

                {tab == 3 &&
                <>  <hr />
                    <h5>Delivery information</h5>
                    <p><strong>Delivery location: </strong>{deliveryLocation}</p>
                    <p><strong>Nearest Landmark: </strong>{landmark}</p>
                    <p><strong>Distance: </strong>{distance} KM</p>
                    <p><strong>Rider: </strong>{rider}</p>
                </>
                }
                
                        
                <p style={{textAlign:'right',color:'red',cursor:'pointer'}} onClick={()=>setModal(false)}>Close</p>
            </div>
        </Modal>

    </div>
  )
}
